import { reactive } from 'vue'
import type { Meeting, MeetingStatus, MeetingType } from '@/types'

export interface MeetingsState {
  meetings: Meeting[]
  selectedMeeting: Meeting | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    status: MeetingStatus | ''
    meetingType: MeetingType | ''
    projectId: string
  }
}

export const getInitialState = (): MeetingsState => ({
  meetings: [],
  selectedMeeting: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: '',
    meetingType: '',
    projectId: '',
  },
})

export const createState = (): MeetingsState => {
  return reactive(getInitialState())
}

export const resetState = (state: MeetingsState): void => {
  const initial = getInitialState()
  state.meetings = initial.meetings
  state.selectedMeeting = initial.selectedMeeting
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
